import classNames from "classnames";

export const inputStyles = "flex w-full items-center gap-x-2.5 text-start";

export const labelStyles = "flex gap-x-1 text-sm text-neutral-500 font-medium";

export const optionsStyles =
  "ring-primary-300 absolute left-0 mt-2 space-y-px overflow-auto rounded-lg border border-neutral-200 bg-white p-2 text-sm font-medium text-neutral-700 shadow-lg focus:outline-none focus-visible:ring-2 min-w-full z-20";

export const getItemStyles = (item: { selected: boolean; active: boolean }) =>
  classNames(
    item.active && "bg-neutral-100",
    "cursor-pointer rounded-md p-2.5 flex items-center gap-2 select-none"
  );
